'use client';
import React from 'react';
import FallbackPage from '@/fallback/FallbackPage';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// https://nextjs.org/docs/app/api-reference/file-conventions/error
export default function Error() {
    return <FallbackPage />;
}
